module.exports = __webpack_public_path__ + "img/37.a9337e31.png";